import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css'; // The animation styles
import Navbar from './Navbar/Navbar'; 
import Footer from './Components/Footer/Footer';
import Home from './Components/Home/Home';
import About from './Components/AboutUs/About';
import Contact from './Components/ContactUs/Contact';
import PrivacyPolicy from './Components/PrivacyPolicy';
import './index.css';

function App() {
  // Initialize the premium scroll animations
  useEffect(() => {
    AOS.init({
      duration: 1000, // Smooth, slow fade-ins (1 second)
      easing: 'ease-out-cubic', // Premium easing curve
      once: true, // Elements only animate in once when you scroll down
      offset: 100, // Triggers animation slightly before the element hits the screen
    });
  }, []);

  return (
    <div className="App">
      <Navbar />  

      <main>
        <section id="home">
          <Home />
        </section>
        
        <section id="about">
          <About />
        </section>
        
        <section id="contact">
          <Contact />
        </section>

        <section id="privacy">
          <PrivacyPolicy />
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default App;